import Vue from 'vue';

export default {
    async getDevices() {
        const response = await Vue.axios.get('/account/devices', {
            headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`},
        }).catch((e) => {
            throw e;
        });
        return response.data.data;
    },
    async getDevice(id) {
        const response = await Vue.axios.get(`/account/devices/${id}`, {
            headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`},
        });
        return response.data.data;
    },
    async updateDevice(id, data) {
        const response = await Vue.axios.patch(
            `/account/devices/${id}`,
            data,
            {headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`}},
        ).catch((e) => {
            throw e;
        });
        return response.data.data;
    },
	async createDevice(id, data) {
		const response = await Vue.axios.patch(
			`/account/devices/${id}`,
			data,
			{headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`}},
		).catch((e) => {
			throw e;
		});
		return response.data.data;
	},
    async getDeviceImage(imagePath) {
        const response = await Vue.axios.get(imagePath, {
            headers: { Authorization: `Bearer ${Vue.store.state.auth.token}` },
            responseType: 'arraybuffer'
        },
        ).catch((e) => {
            throw e;
        });
        return response;
    },
	async requestPin(id) {
		const response = await Vue.axios.post(`/account/devices/${id}/activate`, {} , {
				headers: { Authorization: `Bearer ${Vue.store.state.auth.token}` },
			},
		).catch((e) => {
			throw e;
		});
		return response;
	},
    async uploadDeviceImage(id, data) {
        const response = await Vue.axios.post(
            `/account/devices/${id}/images`,
            data,
            {
            	headers: {
            		Authorization: `Bearer ${Vue.store.state.auth.token}`,
					'Content-Type': 'multipart/form-data'
            	}
            },
        ).catch((e) => {
            throw e;
        });
        return response.data;
    },
    async deleteDeviceImage(deviceId, imageId) {
        const response = await Vue.axios.delete(
            `/account/devices/${deviceId}/images/${imageId}`,
            {headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`}},
        ).catch((e) => {

            throw e;
        });
        return response.data;
    },
    async createDeviceState(deviceId, data) {
        const response = await Vue.axios.post(
            `account/devices/${deviceId}/states`,
            data,
            {headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`}},
        ).catch((e) => {
            throw e.response;
        });
        return response.data;
    }
};
